export default function flipInvert(first, last) {
  const sX = first.width / last.width;
  const sY = first.height / last.height;
  const x = first.left - last.left;
  const y = first.top - last.top;
  const matrix = `matrix(${sX}, 0, 0, ${sY}, ${x}, ${y})`;
  return { sX, sY, x, y, matrix };
}

export function flipTranslate(
  { left: firstLeft = 0, top: firstTop = 0 },
  { left: lastLeft = 0, top: lastTop = 0 }
) {
  const x = firstLeft - lastLeft;
  const y = firstTop - lastTop;
  return `translate(${x}px, ${y}px)`;
}

// type Props = {
//   children: Function,
//   left: number,
//   top: number,
//   prevLeft?: ?number,
//   prevTop?: ?number,
// };

// type State = {
//   shouldAnimate: boolean,
//   translate: string,
// };

// const getPrevPos = (nextProps: Props, prevProps?: ?Props) => ({
//   ...nextProps,
//   left: prevProps
//     ? prevProps.left
//     : nextProps.prevLeft == null ? nextProps.left : nextProps.prevLeft,
//   top: prevProps
//     ? prevProps.top
//     : nextProps.prevTop == null ? nextProps.top : nextProps.prevTop,
// });

// export class FlipTranslate extends React.Component<Props, State> {
//   state = {
//     shouldAnimate: false,
//     translate: '',
//     left: null,
//     top: null,
//   };

//   static getDerivedStateFromProps(nextProps, prevState) {
//     if (nextProps.left !== prevState.left || nextProps.top !== prevState.top) {
//       return {
//         shouldAnimate: true,
//         translate: flipTranslate(getPrevPos(nextProps, prevState), nextProps),
//         left: nextProps.left,
//         top: nextProps.top,
//       };
//     }
//     return null;
//   }

//   componentDidMount() {
//     raf(this.animate);
//   }

//   componentDidUpdate() {
//     if (this.state.shouldAnimate) raf(this.animate);
//   }

//   initialPosition(prevProps: Props, nextProps: Props) {
//     this.setState({
//       shouldAnimate: true,
//       translate: flipTranslate(prevProps, nextProps),
//     });
//   }

//   animate = () => {
//     this.setState({
//       shouldAnimate: false,
//       translate: '',
//     });
//   };

//   render() {
//     return this.props.children(this.state.translate);
//   }
// }
